export enum PatientHistoryQuestionKey {
  clinicalBackground = 'clinicalBackground',
  medication = 'medication',
  surgicalHistory = 'surgicalHistory',
  allergies = 'allergies',
  habits = 'habits',
  familyBackground = 'familyBackground',
}

export enum PatientHistoryQuestionTitle {
  clinicalBackground = 'Antecedentes clínicos',
  medication = 'Medicamentos em uso',
  surgicalHistory = 'Antecedentes cirúrgicos',
  allergies = 'Alergias',
  habits = 'Hábitos',
  familyBackground = 'Antecedentes familiares',
}
